import styled from 'styled-components'

export const ModalContent = styled.div`
  margin: 10px;
`

export const ContainerButton = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`
